import React from 'react';
import { FaMobileAlt, FaUserPlus } from 'react-icons/fa';
import InputField from '../../Components/InputField';
import Button from '../../Components/Button';
import {  handlePhoneInputKeyPress } from '../../Utils/validateForm';
import Alert from '../../Components/Alert';
import { useAddReferral } from '../../Hooks';
import Loading from '../../Components/Loading';


const AddReferral = ({ userId, onSuccess }) => {
    const { values, errors, error, success, isLoading, handleChange, handleSubmit } = useAddReferral(userId, { onSuccess });

    return (
        <div className="p-6">
            <div className="max-w-md mx-auto">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-main1/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FaUserPlus className="text-3xl text-main1" />
                    </div>
                    <h3 className="text-xl font-bold text-main1 mb-2">إضافة إحالة جديدة</h3>
                    <p className="text-sm text-gray-600">أدخل رقم هاتف المحيل لإضافة إحالة جديدة</p>
                </div>

                

                <form className="space-y-6" onSubmit={(e) => { handleSubmit(e); }}>
                    <div>
                        <InputField
                            className="p-3"
                            placeholder="رقم هاتف المحيل"
                            Icon={FaMobileAlt}
                            type="text"
                            name="referrer_phone"
                            value={values.referrer_phone}
                            onChange={handleChange}
                            error={errors.referrer_phone}
                            onKeyPress={e => handlePhoneInputKeyPress(e, e.target.value)}
                        />
                    </div>

                    <Button 
                        type="submit" 
                        className="mt-6"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center gap-3 m-1">
                                <Loading type="dots" size="md" text="جاري الإرسال ..." color="light" />
                            </div>
                        ) : (
                            'إضافة الإحالة'
                        )}
                    </Button>
                </form>

                {error && <Alert type="error">{error}</Alert>}
                {success && <Alert type="success">{success}</Alert>}

            </div>
        </div>
    );
};

export default AddReferral;
